/*
 * @Author: cc
 * @Date:2016-4-13
 * @LastEditTime: 2021-03-02 10:30:13
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\trsImageUpload\trsUploadDirective.js
 * @Description: 图集稿，碎片化图片上传指令
 */
'use strict';

angular.module('pieceMgr.imgUpload', []).directive('trsUpload', [
    '$q',
    'loginService',
    'globleParamsSet',
    'modalDialog',
    'editCenUploadVideoForXjService',
    function ($q, loginService, globleParamsSet, modalDialog, editCenUploadVideoForXjService) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                diruploadSrc: '=',
                diruploadName: '=',
                callBack: '=',
            },

            templateUrl: './components/util/trsImageUpload/uploaderService.html',
            link: function (scope, element, attr) {
                var server = attr.src;
                var formData = attr.formdata ? JSON.parse(attr.formdata) : {};
                scope.status = {
                    Q_TYPE_DENIED: '请检查文件格式，允许上传类型：' + editCenUploadVideoForXjService.singleImageOption.extensions,
                    Q_EXCEED_SIZE_LIMIT: '请检查文件大小',
                };
                loadWebuploader().then(function (WebUploader) {
                    uploaderLazy(WebUploader);
                });
                getUserInfo();

                /**
                 * [uploaderLazy description] 上传文件
                 * @param   {[type]}  WebUploader  [WebUploader description]
                 * @return  {[type]}               [return description]
                 */
                function uploaderLazy(WebUploader) {
                    // WebUploader提供的钩子（hook）， 为了先执行获取md5的
                    WebUploader.Uploader.register(
                        {
                            'before-send-file': 'beforeSendFile', // 整个文件上传前
                        },
                        {
                            beforeSendFile: function (file) {
                                var deferred = WebUploader.Deferred();
                                // 上传前请求服务端,判断文件是否已经上传过
                                uploader.md5File(file).then(function (val) {
                                    uploader.option('server', server + '?md5=' + val);
                                    if (formData) {
                                        uploader.option('formData', formData);
                                    }
                                    deferred.resolve();
                                });
                                return deferred.promise();
                            },
                        }
                    );
                    var uploader = WebUploader.create({
                        // 选完文件后，是否自动上传
                        auto: true,
                        // swf文件路径
                        // swf: BASE_URL + '/js/Uploader.swf',
                        swf: './webuploader/util/Uploader.swf',
                        server: server,
                        // 选择文件的按钮。可选。
                        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
                        threads: 10,
                        pick: {
                            id: element[0],
                            label: attr.innerName,
                            multiple: attr.multiple !== 'false',
                        },
                        // 只允许选择图片文件。
                        method: 'POST',
                        compress: false,
                        // 接收文件的类型
                        accept: editCenUploadVideoForXjService.singleImageOption,
                        duplicate: true, // 可重复
                    });
                    uploader.on('filesQueued', function (file) {
                        scope.callBack.file(file, uploader);
                    });
                    uploader.on('uploadSuccess', function (file, src) {
                        if (src.code && src.code === '500') {
                            scope.callBack.error(file, src.msg);
                        } else {
                            scope.callBack.success(file, src);
                        }
                    });
                    uploader.on('error', function (str) {
                        modalDialog.alertType('上传失败', scope.status[str], 'error', false);
                    });
                    uploader.on('uploadError', function (file) {
                        scope.callBack.error(file);
                    });
                    uploader.on('uploadProgress', function (file, percentage) {
                        scope.callBack.tar(file, percentage);
                    });
                    uploader.on('uploadComplete', function (file) {
                        scope.callBack.comp(file);
                    });
                    uploader.on('uploadStart', function (file) {
                        scope.callBack.start(file);
                    });
                    uploader.on('uploadFinished', function (file) {
                        scope.callBack.finish(file);
                    });
                    uploader.on('uploadBeforeSend', function (obj, data, headers) {
                        headers.token = scope.token.token;
                    });
                }

                /**
                 * [getUserInfo description]获取用户信息以及token
                 * @return  {[type]}  [return description]
                 */
                function getUserInfo() {
                    loginService
                        .getCurrLoginUser()
                        .then(function (user) {
                            return globleParamsSet.getTokenService(user.TENANTID);
                        })
                        .then(function (tokenInfo) {
                            scope.token = tokenInfo;
                        });
                }

                /**
                 * [loadWebuploader description] 加载webuploader.js
                 * @return  {[type]}  [return description]
                 */
                function loadWebuploader() {
                    var deffer = $q.defer();
                    if (typeof define === 'function' && define.amd) {
                        // AMD
                        require(['./lib/generalUpLoad/webuploader.js'], function (WebUploader) {
                            deffer.resolve(WebUploader);
                        });
                    } else {
                        LazyLoad.js(['./lib/requirejs/require.js'], function () {
                            require(['./lib/generalUpLoad/webuploader.js'], function (WebUploader) {
                                deffer.resolve(WebUploader);
                            });
                        });
                    }
                    return deffer.promise;
                }
            },
        };
    },
]);
